var indentation_default = {
  "indentZero": "NMMLE",
  "indentOne": "lWdai",
  "indentTwo": "iO-WD",
  "indentThree": "dEqPi",
  "indentFour": "mZ4J3",
  "indentFive": "RWUYx",
  "indentSix": "NmW5G"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
